import { render } from "./Scan.vue?vue&type=template&id=704f4b1a"
import script from "./Scan.vue?vue&type=script&lang=js"
export * from "./Scan.vue?vue&type=script&lang=js"

import "./Scan.vue?vue&type=style&index=0&id=704f4b1a&lang=scss"

import exportComponent from "/home/caleb/Desktop/apps/eventusa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__